/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/172-magnet': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M14 0h-4l1 9a3 3 0 11-6 0l1-9H2L1 9a7 7 0 1014 0l-1-9zm-1.846 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-.611-4.154-1.721a5.834 5.834 0 01-1.72-4.095l.564-5.075h1.736l-.55 4.953v.062c0 1.102.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-.429 2.917-1.208a4.098 4.098 0 001.208-2.917v-.062l-.007-.062-.543-4.891h1.736l.564 5.075a5.838 5.838 0 01-1.72 4.095z"/>'
  }
})
